<template>
  <div class="hose-settings">
    <tabs
        tooltip-key="tooltip_hose_unit"
        :label="$t('hose.settings.units')"
        :options="{
          'bar': $t('hose.settings.bar'),
          'psi': $t('hose.settings.psi'),
        }"
        v-model="unit"
    ></tabs>
    <tabs
        tooltip-key="tooltip_hose_appliance"
        :label="$t('hose.settings.application')"
        :options="{
          'hydraulic': $t('hose.settings.hydraulics'),
          'water': $t('hose.settings.water'),
        }"
        v-model="application"
    ></tabs>

    <input-field
        tooltip-key="tooltip_hose_pressure"
        :label="$t('hose.pressure')"
        type="number"
        :suffix="preferences.unit === 'bar' ? 'Bar' : 'PSI'"
        v-model="pressure"
    ></input-field>

    <input-field
        tooltip-key="tooltip_hose_liters"
        :label="$t('hose.settings.lpm')"
        type="number"
        suffix="l/min"
        v-model="hoseLpm"
    ></input-field>

    <input-field
        tooltip-key="tooltip_hose_length"
        :label="$t('hose.length')"
        type="number"
        suffix="mm"
        v-model="hoseLength"
    ></input-field>

  </div>
</template>

<script>
import Tabs from "@/components/hose/components/Tabs";
import InputField from "@/components/hose/components/InputField";

import {mapGetters} from "vuex";

import {PSI_FACTOR} from "@/helpers/calculations";

export default {
  name: "HoseSettings",

  components: {
    InputField,
    Tabs
  },

  computed: {
    ...mapGetters({
      preferences: 'build/hoses/getHosePreferences',
      PSI: 'build/hoses/getPSI'
    }),
    hoseLength: {
      get() {
        return this.preferences.length;
      },
      set(val) {
        this.$store.commit('build/hoses/setLength', +val);
      },
    },
    hoseLpm: {
      get() {
        return this.preferences.lpm;
      },
      set(val) {
        this.$store.commit('build/hoses/setLpm', +val);
      },
    },
    unit: {
      get() {
        return this.preferences.unit;
      },
      set(val) {
        this.$store.commit('build/hoses/setUnit', val);
      },
    },
    application: {
      get() {
        return this.preferences.application;
      },
      set(val) {
        this.$store.commit('build/hoses/setApplication', val);
      },
    },
    pressure: {
      get() {
        let pressure = this.preferences.pressure;
        if(this.preferences.unit === 'bar') {
          return Math.round(pressure * 100) / 100;
        } else {
          return Math.round(pressure * PSI_FACTOR * 100) / 100;
        }
      },
      set(val) {
        if(this.preferences.unit === 'bar') {
          this.$store.commit('build/hoses/setPressure', +val);
        } else {
          this.$store.commit('build/hoses/setPressure', (+val / PSI_FACTOR));
        }
      },
    },
  },
}
</script>

<style scoped lang="scss">
  .hose-settings {
    grid-row-start: 3;
    grid-row-end: 5;
    background-color: #FAFAFA;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.06);
    padding: 12px 14px 19px 19px;
    max-height: 440px;

    .tabs {
      margin-bottom: 15px;
    }
  }
</style>